import { render, staticRenderFns } from "./Windows.vue?vue&type=template&id=030ac3eb&lang=pug&"
import script from "./Windows.vue?vue&type=script&lang=js&"
export * from "./Windows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports